import React, { useState } from 'react';
import t from '@guestyci/localize/t.macro';
import {
  Text,
  Heading,
  Stack,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@guestyci/arc';
import { StepActions } from '../../layout';

const DEVICE_OPTIONS = {
  IPHONE: 'APPLE',
  ANDROID: 'ANDROID',
};

const STORE_LINKS = {
  [DEVICE_OPTIONS.IPHONE]: {
    url: 'https://apps.apple.com/app/google-authenticator/id388497605',
    label: () => t('Google Authenticator from the App Store'),
  },
  [DEVICE_OPTIONS.ANDROID]: {
    url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    label: () => t('Google Authenticator from Google Play'),
  },
};

const SetupStep = ({ onNext, onPickDifferentMethod, isSubmitting }) => {
  const [selectedDevice, setSelectedDevice] = useState('');

  const handleNext = () => {
    if (!selectedDevice) return;
    onNext();
  };

  const storeInfo = STORE_LINKS[selectedDevice];

  return (
    <Stack spacing={6} justify="between" className="gst-w-full gst-flex-1">
      <Stack spacing={6}>
        <Stack spacing={4}>
          <Heading variant="h2">{t('Set up Google Authenticator')}</Heading>
          <Text size="sm">{t('Select your device type')}</Text>
        </Stack>

        <RadioGroup
          value={selectedDevice}
          onValueChange={setSelectedDevice}
          className="gst-gap-4"
        >
          <Stack spacing={2} direction="row" align="center">
            <RadioGroupItem value={DEVICE_OPTIONS.IPHONE} id="device-iphone" />
            <Label htmlFor="device-iphone" className="gst-cursor-pointer">
              {t('iPhone')}
            </Label>
          </Stack>
          <Stack spacing={2} direction="row" align="center">
            <RadioGroupItem value={DEVICE_OPTIONS.ANDROID} id="device-android" />
            <Label htmlFor="device-android" className="gst-cursor-pointer">
              {t('Android')}
            </Label>
          </Stack>
        </RadioGroup>

        {storeInfo && (
          <Text size="sm" type="secondary">
            {t('Download the')}{' '}
            <a
              href={storeInfo.url}
              target="_blank"
              rel="noopener noreferrer"
              className="gst-text-primary gst-no-underline hover:gst-underline"
            >
              {storeInfo.label()}
            </a>{' '}
            {t('onto your mobile device.')}
          </Text>
        )}
      </Stack>

      <StepActions
        onPrimaryClick={handleNext}
        primaryDisabled={!selectedDevice}
        onSecondaryClick={onPickDifferentMethod}
        isSubmitting={isSubmitting}
      />
    </Stack>
  );
};

export default SetupStep;
